export default __webpack_public_path__ + "static/media/client-19.3bacacf1.webp";